import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
  Stack,
} from "@chakra-ui/react";
import FormController from "@raiden/library/components/ReactHookForm/FormController";
import { useSearchInfiniteContext } from "@raiden/library/contexts/SearchInfinite/useSearchInfiniteContext";
import { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Icon } from "../../../components/Icon";

export function Filters() {
  const intl = useIntl();

  /** @type {import("@raiden/library/contexts/SearchInfinite/useSearchInfiniteContext").UseSearchInfiniteReturn<import(".").NewsSearchFormValues>} */
  const { submit, form, appliedFilters, reset, swrInfiniteResponse } =
    useSearchInfiniteContext();
  const { control } = form;

  const [areFiltersVisible, setAreFiltersVisible] = useState(false);

  const handleClickTune = useCallback(() => {
    setAreFiltersVisible((areFiltersVisible) => !areFiltersVisible);
  }, []);

  return (
    <Stack spacing="0.375rem">
      <Box>
        <form onSubmit={submit}>
          <HStack spacing="1rem">
            <FormController
              control={control}
              name="term"
              flexGrow={1}
              render={(field) => (
                <InputGroup size="lg">
                  <InputLeftElement pointerEvents="none">
                    <Box p="8px">
                      <Icon icon="ms_search" size="32px" />
                    </Box>
                  </InputLeftElement>

                  <Input
                    type="search"
                    placeholder={intl.formatMessage({
                      defaultMessage: "Rechercher...",
                    })}
                    w="full"
                    {...field}
                  />
                </InputGroup>
              )}
            />

            <Button
              onClick={submit}
              isLoading={swrInfiniteResponse.isLoading}
              colorScheme="brandPrimary"
              size="lg">
              <FormattedMessage defaultMessage="Rechercher" />
            </Button>
          </HStack>
        </form>

        <Box display={{ base: "block", lg: "none" }}>
          <IconButton
            onClick={handleClickTune}
            icon={<Icon icon="ms_tune" />}
            position="relative"
            ml="0.75rem"
            variant="outline"
            colorScheme="brandPrimary"
            color={areFiltersVisible ? "#fff" : "brandPrimary.500"}
            backgroundColor={areFiltersVisible ? "brandPrimary.500" : "#fff"}
            borderColor="brandPrimary.500"
            _focus={{
              borderColor: "brandPrimary.500",
              backgroundColor: areFiltersVisible
                ? "var(--chakra-colors-brandPrimary-500) !important"
                : "#fff !important",
            }}
            aria-label={intl.formatMessage({ defaultMessage: "Filtrer" })}
            _after={
              appliedFilters.filter((filter) => filter !== "term").length > 0
                ? {
                    content: `"${
                      appliedFilters.filter((filter) => filter !== "term")
                        .length
                    }"`,
                    position: "absolute",
                    top: "0",
                    right: "0",
                    backgroundColor: "brandSecondary.500",
                    color: "#fff",
                    px: ".5rem",
                    borderRadius: "full",
                    fontsize: "16px",
                    fontWeight: 400,
                    lineHeight: "1.5rem",
                    transform: "translate(50%, -50%)",
                  }
                : undefined
            }
          />
        </Box>

        <Flex
          justify="flex-end"
          pt=".25rem"
          opacity={appliedFilters.length > 0 ? 1 : 0}
          visibility={appliedFilters.length > 0 ? "visible" : "hidden"}
          transition="all .25s ease">
          <Link
            onClick={reset}
            textAlign="right"
            fontSize="0.75rem"
            color="gray.600">
            <FormattedMessage defaultMessage="Réinitialiser les filtres" />
          </Link>
        </Flex>
      </Box>
    </Stack>
  );
}
